export const tipoDocumentoCedula = "1";
export const tipoDocumentoCarnet = "2";

export const ESTADOS_PRECERTIFICACION = {
  TODOS: { texto: "Todos", valor: 0 },
  ABIERTA: { texto: "Abierta", valor: 1 },
  EN_EJECUCION: { texto: "En Proceso", valor: 2 },
  ESCALADO: { texto: "Escalado Técnica Salud", valor: 3 },
  DEVUELTA: { texto: "Devuelto", valor: 4 },
  APROBADO: { texto: "Aprobado", valor: 5 },
  DECLINADO: { texto: "Declinado", valor: 6 }
};

export const POWER_BI_DASHBOARD = {
  title: process.env.REACT_APP_POWERBI_DASHBOARD_TITLE,
  url: process.env.REACT_APP_POWERBI_DASHBOARD_URL
};
